var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.genCls([_vm.layout, _vm.size])},[(_vm.title || _vm.$slots.title)?_c('div',{class:_vm.genCls('title')},[_vm._t("title",function(){return [_vm._v(_vm._s(_vm.title))]})],2):_vm._e(),_c('ARow',{attrs:{"gutter":_vm.gutter,"column":_vm.column}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }